import { Organization } from '../../organizations/types/organization.type';
import { OrderItem } from '../types/order-item.type';
import { DeliveryDay } from '../types/delivery-selection.type';
import { OrderStatus } from '../types/order-status.type';
import { OrderAdvStatus } from '../types/order-adv-status.type';
import { AdminCreateOrganizationOrderDTO } from '../types/dtos/admin-create-order.dto';

export type OrganizationOrderOwner = {
  id: string;
  firstname: string;
  lastname: string;
  phone?: string;
};

export type BuildOrganizationOrderPayloadInput = {
  organization: Organization;
  owner: OrganizationOrderOwner;
  deliveryPointId: string;
  items: OrderItem[];
  deliveryDay: DeliveryDay;
  status: OrderStatus;
  advStatus: OrderAdvStatus;
  deliveryCost: number;
};

export function buildOrganizationOrderPayload(input: BuildOrganizationOrderPayloadInput): AdminCreateOrganizationOrderDTO {
  const { organization, owner, deliveryPointId, items, deliveryDay, status, advStatus, deliveryCost } = input;

  return {
    deliveryType: 'organization',
    organizationId: organization.id,
    deliveryPointId,
    owner: {
      id: owner.id,
      firstName: owner.firstname,
      lastName: owner.lastname,
      ...(owner.phone && { phoneNumber: owner.phone }),
    },
    status,
    advStatus,
    deliveryDate: deliveryDay.date.format('YYYY-MM-DD'),
    deliverySchedule: deliveryDay.schedule,
    deliveryCost,
    billingAddress: {
      title: organization.name,
      address: organization.address.street,
      zipCode: organization.address.zipCode,
      city: organization.address.city,
      ...(organization.address.informations && { complement: organization.address.informations }),
    },
    products: items
      .filter((item) => item.type !== 'basket' && item.type !== 'virtual')
      .map((item) => ({ id: item.productId ?? '', type: 'product' as const, quantity: item.quantity })),
    baskets: items
      .filter((item) => item.type === 'basket')
      .map((item) => ({ id: item.productId ?? '', type: 'basket' as const, quantity: item.quantity })),
    virtuals: items
      .filter((item) => item.type === 'virtual')
      .map((item) => ({
        type: 'virtual' as const,
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        tvaRate: item.tvaRate,
        size: item.size,
        noLabel: item.noLabel,
        valueZero: item.valueZero,
      })),
  };
}
